import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgQrcodeComponent } from './svg-qrcode.component';



@NgModule({
    declarations: [
        SvgQrcodeComponent
    ],
    exports: [
        SvgQrcodeComponent
    ],
    imports: [
        CommonModule
    ]
})
export class SvgQrcodeModule { }
